import React, { useState, useEffect } from "react";
import classes from "../style/Style.module.css";
import "../style/Infoscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DexterCall from "../Images/UpdatedDexter-call.svg";
import {
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_NOMINEE_DETAILS,
} from "../Routes";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Toast from "../Components/ToastMsg/Toast";
import { selectPhoneNumber } from "../Store/MobileSlice";
import axios from "../libs/axiosConfig";
import { useSelector } from "react-redux";
import { selectPanNumber } from "../Store/panNumberSlice";
import { selectRefreshToken } from "../Store/Token/refreshTokenSlice";
import Modal from "react-modal";
import LogoutModal from "../Components/LogoutModal";


const Checkboxes = () => {
  const Navigate = useNavigate();
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const [selectedBoxes, setSelectedBoxes] = useState([]);
  const [apiData, setApiData] = useState(null);
  const phoneNumber = useSelector(selectPhoneNumber);
  const panNumber = useSelector(selectPanNumber);
  const refreshToken = useSelector(selectRefreshToken);
  const [showModal, setShowModal] = useState(false);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);
  const [isLoading, setIsLoading] = useState(false);
  const [relevantData, setRelevantData] = useState(null);

  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);


  useEffect(() => {
    // setApiCallsInProgress(apiCallsInProgress + 1);
    const fetchApiData = async () => {
      try {
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${storedToken}`,
          //  RefreshToken: refreshToken

        };
        const requestBody = {
          dexterrCustomerBasicQuestions: {
            mobile_no: phoneNumber,
            request_type: "get",
            country_code: "+91"
          }
        };
        
        
        const response = await axios.post(
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",requestBody,
          {
            headers: headers,
          }
        );

        if (response.status === 200) {
          const data = response.data;
          setApiData(data);

          const extractedData = {
            mobileNumber: data.data.phoneNumber || "",
            pan: data.data.pan || "",
          };
          setRelevantData(extractedData);
        } else {
          console.error(response.data.message);
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    };

    fetchApiData();
  }, [storedToken]);


  const HandleBack = () => {
    setShowModal(true);
  };
  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };
  const handleBoxClick = (index) => {
    const newSelectedBoxes = [...selectedBoxes];
    const currentIndex = newSelectedBoxes.indexOf(index);

    if (currentIndex === -1) {
      newSelectedBoxes.push(index);
    } else {
      newSelectedBoxes.splice(currentIndex, 1);
    }
    // Toast.success("residential status selected");
    setSelectedBoxes(newSelectedBoxes);
  };

  const isSelected = (index) => {
    return selectedBoxes.includes(index);
  };

  const options = [
    {
      heading: "I am not a politically exposed person or related to one.",
    },
    {
      heading: "I am a Resident Indian and not a taxpayer outside India.",
    },
    {
      heading:
        "I hereby confirm that the mobile number linked to my Dexterr account belongs to me.",
    },
  ];

  const HandelSubmit = async () => {
    setApiCallsInProgress(apiCallsInProgress + 1);
    if (apiData && apiData.data.resident && apiData.data.resident.startsWith("NRI")) {
      if (selectedBoxes.length === 2) {
        if (selectedBoxes.length !== 2) {
          Toast.error("Please select both options and confirm.");
          return;
        }
      }
    } else {
      if (selectedBoxes.length !== 3) {
        Toast.error("Please select all three checkboxes and confirm.");
        return;
      }
    }
  
    const fristAPI =
      "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
    // const SecondAPI =
    //   "https://partnerapp.ambrela.money/api/AddCustomerKycDetails";
  
    // const headers = {
    //   "Content-Type": "application/json",
    //   Authorization: `Bearer ${storedToken}`,
    //   // RefreshToken: refreshToken
    // };
  
    try {
      let politicallyExposedPersonValue = "";
      let relatedToPoliticallyExposedPersonValue = "";
  
      if (selectedBoxes.length === 3) {
        politicallyExposedPersonValue = "NO";
        relatedToPoliticallyExposedPersonValue = "NO";
      } else if (
        selectedBoxes.includes(0) &&
        selectedBoxes.includes(2) &&
        selectedBoxes.length === 2
      ) {
        politicallyExposedPersonValue = "NO";
        relatedToPoliticallyExposedPersonValue = "NO";
      } else {
        Toast.error("Please select checkboxes and confirm");
        return;
      }
  
      const response = await axios.post(
        fristAPI,
        {
          CustomerKycDetails: {
            request_type: "post",
            // country_code: "+91",
            mobileNumber: phoneNumber,
            ...relevantData,

            politicallyExposedPerson: politicallyExposedPersonValue,
            relatedToPoliticallyExposedPerson:
              relatedToPoliticallyExposedPersonValue,
          },
        },
        // { headers }
      );
  
      if (response.status === 200 && response.data) 
      {
        
        
          Navigate(ROUTE_NOMINEE_DETAILS);
        
      } else {
        Toast.error(response.data.message + " " + response.data.errorMessage);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      Toast.error(
        error.response.data.errorMessage +
          " " +
          error.response.data.message ||
          "Error"
      );
    }
  };
  

  return (
    <div className="Residential_Main_Container">
      <div className="Rjected_KYC_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
      </div>
      <div className="ResidentialStatus_Container">
        <p className="Question_Heading_text">
          Confirming few things.
        </p>
        <div className="Select_Residence_Container">
          {options.map((option, index) =>
            apiData &&
              apiData.data.resident &&
              apiData.data.resident.startsWith("NRI") &&
              index === 1 ? null : (
              <div
                key={index}
                className={classes.Select_Box}
                style={{
                  background: isSelected(index)
                    ? "linear-gradient(90deg, rgba(0, 0, 0, 0.2) -1.5%, rgba(1, 61, 196, 0.2) 101.05%)"
                    : "",
                }}
                onClick={() => handleBoxClick(index)}
              >
                <p className="Option_Label">
                  <span className="Label_Heading_Text">
                    {option.heading}
                  </span>
                </p>
                <button
                  className="Select_Button"
                  style={{
                    background: isSelected(index) ? "#013DC4" : "",
                  }}
                />
              </div>
            )
          )}
        </div>
        <button className={classes.Next_button} onClick={HandelSubmit}>
          Next
        </button>
      </div>
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default Checkboxes;